import { loader } from 'graphql.macro';

export const surfaceUnionReferencesFragment = loader('./index.graphql');
